export default __webpack_public_path__ + "static/img4@2x-c27b8e99b79177d029a37b401ac3fa5b.png";